"use client";

import { Toaster as Sonner } from "sonner";

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="dark"
      position="top-right"
      duration={6000}
      icons={{
        success: null,
        error: null,
      }}
      toastOptions={{
        style: {
          background: "linear-gradient(180deg, #121124 0%, #0e0821 100%)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          color: "rgba(255, 255, 255, 0.9)",
          borderRadius: "18px",
          fontSize: "15px",
          fontWeight: 300,
          padding: "20px 24px",
          minWidth: "340px",
          boxShadow: "0 12px 40px rgba(0, 0, 0, 0.5), 0 0 80px rgba(135, 82, 250, 0.06)",
        },
        classNames: {
          title: "!text-[15px] !font-semibold",
          description: "!text-[13px] !text-white/50 !font-light !mt-[3px]",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
